<template>
  <div v-if="result" class="catalog-look">
    <div class="catalog-look-banner" @mouseover="isHover = true" @mouseleave="isHover = false">
      <DefPicture :result="result.pictures" />
      <LookButton
        v-if="filterProducts?.items?.length > 0"
        :is-hover="isHover || screenWidth < 992"
        @click="handlerOpenModal"
      >
        {{ messages.watchTheLook }}
      </LookButton>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import DefPicture from '@components/Def/DefPicture/DefPicture.vue';
import CatalogLookModal from '@components/Catalog/CatalogLookModal.vue';
import useScreenWidth from '@use/useScreenWidth';
import LookButton from '@components/Look/LookButton.vue';
import useModalAside from '@use/useModalAside/useModalAside';

export default {
  name: 'CatalogLook',
  components: {
    LookButton,
    DefPicture,
  },
  props: ['result'],
  data() {
    return {
      isHover: false,
      screenWidth: useScreenWidth(),
      modalAside: useModalAside(),
    };
  },
  computed: {
    ...mapState({
      messages: ({ results }) => results.messages,
    }),
    ...mapGetters({
      isAvailable: 'product/isAvailable',
    }),
    filterProducts() {
      const items = this.result.displayProperties?.PRODUCTS?.items.filter((el) =>
        this.isAvailable(el)
      );
      return {
        ...this.result.displayProperties.PRODUCTS,
        items,
      };
    },
  },
  methods: {
    handlerOpenModal() {
      this.modalAside.show(CatalogLookModal, { result: this.filterProducts }, {});
    },
  },
};
</script>

<style lang="scss" scoped>
.catalog-look {
}
.catalog-look-banner {
  position: relative;
  :deep(.def-picture__image) {
    width: 100%;
  }
}
</style>
